import { readVehicles } from '@/helpers/externals/vehicles'

const state = {
  vehicles: []
}

const getters = {
  getVehicles: state => [...state.vehicles],
  getVehicleById: (state) => (id) => {
    return state.vehicles.find(vehicle => vehicle.id === id)
  }
}

const mutations = {
  setVehicles(state, payload) {
    state.vehicles = payload.map(vehicle => {
      return {
        id: vehicle.pk.toString(),
        immat: vehicle.fields.vehicle_registration,
        type: vehicle.fields.segment,
        description: vehicle.fields.description,
        typeAccount: 'twip_employee'
      }
    })
  },
  clearVehicles(state) {
    state.vehicles = []
  },
  addVehicle(state, payload) {
    state.vehicles = [
      {
        id: payload.pk.toString(),
        immat: payload.fields.vehicle_registration,
        type: payload.fields.segment,
        description: payload.fields.description,
        typeAccount: 'twip_employee'
      },
      ...state.vehicles,
    ]
  },
  editVehicle(state, payload) {
    state.vehicles = state.vehicles.map(vehicle => {
      if (vehicle.id !== payload.pk.toString()) {
        return vehicle
      }
      return {
        id: payload.pk.toString(),
        immat: payload.fields.vehicle_registration,
        type: payload.fields.segment,
        description: payload.fields.description,
        typeAccount: 'twip_employee'
      }
    })
  },
  deleteVehicle(state, payload) {
    state.vehicles = state.vehicles.filter(vehicle => {
      return vehicle.id !== payload
    })
  }
}

const actions = {
  async getVehicles() {
    await readVehicles()
  },

  addVehicle({ commit }, payload) {
    commit('addVehicle', payload)
  },

  editVehicle({ commit }, payload) {
    commit('editVehicle', payload)
  },

  deleteVehicle({ commit }, payload) {
    commit('deleteVehicle', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}